import { register as registerSwiperElemets } from "swiper/element/bundle";
import SwiperInstances from "./modules/_SwiperInstances";

registerSwiperElemets(); //This registers Swiper's custom HTML elements

window.swiperInstances = new SwiperInstances();
